class e extends Error {
  constructor(r) {
    super(r), this.name = "SVError";
  }
}
const t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SVError: e
}, Symbol.toStringTag, { value: "Module" }));
export {
  e as S,
  t as e
};
